var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import SystemSettingsService from '../../api/SystemSettingsService';
import EditDialog from './components/EditDialog';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        return _this;
    }
    List.prototype.created = function () {
        this.service = SystemSettingsService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        this.getList();
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    List.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getThirdPartyPaymentList(Object.assign({}, pager)).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    List.prototype.add = function () {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {
                isEdit: false,
                data: {},
            }
        }, {
            title: "添加支付方式",
            width: 560,
            height: 440
        }).instance;
        instance.$on("editDialog:ok", function () {
            _this.getList();
        });
    };
    List.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {
                isEdit: true,
                data: row
            }
        }, {
            title: "编辑支付方式",
            width: 560,
            height: 440
        }).instance;
        instance.$on("editDialog:ok", function () {
            _this.getList();
        });
    };
    List.prototype.addOrModifyAjax = function (params, isEdit) {
        var _this = this;
        if (isEdit === void 0) { isEdit = false; }
        var promiseResult = isEdit ? this.service.editPay(params) : this.service.addPay(params);
        var successMsg = isEdit ? '编辑成功' : '添加成功';
        promiseResult.then(function (res) {
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || successMsg);
                setTimeout(function () {
                    _this.getList();
                }, 300);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (error) {
            _this.$message.error(error.msg || error.message);
        });
    };
    List.prototype.deleteRow = function (row) {
        var _this = this;
        this.$confirm('确定要删除该支付方式吗？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.deletePay({
                    payment_config_id: row.payment_config_id
                }).then(function (res) {
                    if (res.data && res.data.success) {
                        _this.$message.success(res.data.msg || '删除成功');
                        setTimeout(function () {
                            _this.getList();
                        }, 300);
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                });
            }
        }).catch(function () { });
    };
    List = __decorate([
        Component
    ], List);
    return List;
}(Vue));
export default List;
